import { render, staticRenderFns } from "./pais.vue?vue&type=template&id=7b244126&"
import script from "./pais.vue?vue&type=script&lang=js&"
export * from "./pais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports